// extracted by mini-css-extract-plugin
module.exports = {"table":"MarkdownTable-module--table--1joVK"};